module.exports = __webpack_public_path__ + "static/media/i-inka-icon.1857bace.svg";